/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import LinkedListByBuilding from '../LinkedListByBuilding';
const isCtaBuilding = (b: any): boolean =>
  String(b?.building_code || '').toLowerCase() === 'cta' ||
  String(b?.building_type_name || '').toLowerCase().includes('cta');

interface BuildingsModerationTabProps {
  userId: any;
  filteredItems: any;
  thCls: any;
  tdCls: any;
  editingId: any;
  editForm: any;
  setEditForm: any;
  startEdit: any;
  cancelEdit: any;
  handleSave: any;
  handleDelete: any;
  toggleBuildingActive: any;
  updateBuildingCta: any;
  buildingCtaLink: any;
  setBuildingCtaLink: any;
  ctaBuildings: any;
  possessionData: any;
}

const BuildingsModerationTab: React.FC<BuildingsModerationTabProps> = ({
  userId,
  filteredItems,
  thCls,
  tdCls,
  editingId,
  editForm,
  setEditForm,
  startEdit,
  cancelEdit,
  handleSave,
  handleDelete,
  toggleBuildingActive,
  updateBuildingCta,
  buildingCtaLink,
  setBuildingCtaLink,
  ctaBuildings,
  possessionData,
}) => (
        <div className="overflow-x-auto rounded border border-[#33456f]">
          <table className="w-full min-w-[860px] border-collapse">
            <thead>
              <tr>
                <th className={thCls}>ID</th>
                <th className={thCls}>Type</th>
                <th className={thCls}>État</th>
                <th className={thCls}>Nom</th>
                <th className={thCls}>Niv.</th>
                <th className={thCls}>Lien CTA</th>
                <th className={thCls}>Capacités / postes</th>
                <th className={`${thCls} w-[1%] whitespace-nowrap`}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((b: any) => {
                const cta = isCtaBuilding(b);
                const isEd = editingId === Number(b.id);
                return (
                  <React.Fragment key={b.id}>
                    <tr>
                      <td className={tdCls}>#{b.id}</td>
                      <td className={tdCls}>
                        <div className="flex flex-wrap items-center gap-1">
                          <span className="text-base">{b.building_icon || '🏢'}</span>
                          <span>{b.building_type_name || '—'}</span>
                          {cta && (
                            <span className="rounded bg-violet-900/60 px-1.5 py-0.5 text-[9px] uppercase text-violet-200">CTA</span>
                          )}
                        </div>
                      </td>
                      <td className={tdCls}>
                        <span
                          className={`inline-flex rounded px-2 py-0.5 text-[10px] font-medium ${
                            Number(b.actif) ? 'bg-emerald-900/50 text-emerald-200' : 'bg-slate-700/80 text-slate-300'
                          }`}
                        >
                          {Number(b.actif) ? 'Actif' : 'Inactif'}
                        </span>
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          b.nom
                        ) : (
                          <input
                            value={editForm.nom || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, nom: e.target.value }))}
                            className="w-full min-w-[140px] rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[11px] text-slate-100"
                            placeholder="Nom"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          b.niveau
                        ) : (
                          <input
                            type="number"
                            min={1}
                            value={editForm.niveau || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, niveau: e.target.value }))}
                            className="w-16 rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[11px] text-slate-100"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {cta ? (
                          <span className="text-[10px] text-slate-500">— (CTA, pas de lien vers un autre CTA)</span>
                        ) : (
                          <div className="flex flex-col gap-1">
                            <select
                              value={buildingCtaLink[Number(b.id)] ?? String(b.cta_id || '')}
                              onChange={(e) => setBuildingCtaLink((prev: any) => ({ ...prev, [Number(b.id)]: e.target.value }))}
                              className="max-w-[220px] rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[10px] text-slate-100"
                            >
                              <option value="">Aucun CTA</option>
                              {ctaBuildings.map((c: any) => (
                                <option key={c.id} value={String(c.id)}>
                                  #{c.id} — {c.nom} ({c.actif ? 'Actif' : 'Inactif'})
                                </option>
                              ))}
                            </select>
                            <span className="text-[9px] text-slate-500">CTA lié : {b.cta_id ? `#${b.cta_id}` : 'aucun'}</span>
                          </div>
                        )}
                      </td>
                      <td className={`${tdCls} text-[10px] text-slate-400`}>
                        Pers. {b.capacite_personnel ?? 0} / Véh. {b.capacite_vehicules ?? 0} · postes {b.postes_occupes ?? 0}/{b.postes_disponibles ?? 0} · pl. {b.vehicules_places ?? 0}
                      </td>
                      <td className={tdCls}>
                        <div className="flex flex-col gap-1">
                          {!isEd ? (
                            <button
                              type="button"
                              onClick={() => startEdit(b)}
                              className="rounded bg-amber-600 px-2 py-0.5 text-[10px] text-white hover:bg-amber-500"
                            >
                              Modifier
                            </button>
                          ) : (
                            <div className="flex flex-wrap gap-1">
                              <button
                                type="button"
                                onClick={() => void handleSave(userId, b)}
                                className="rounded bg-emerald-600 px-2 py-0.5 text-[10px] text-white"
                              >
                                Enregistrer
                              </button>
                              <button type="button" onClick={cancelEdit} className="rounded bg-slate-600 px-2 py-0.5 text-[10px] text-white">
                                Annuler
                              </button>
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => void toggleBuildingActive(Number(b.id), !Number(b.actif))}
                            className={`rounded px-2 py-0.5 text-[10px] text-white ${
                              Number(b.actif) ? 'bg-amber-700 hover:bg-amber-600' : 'bg-emerald-700 hover:bg-emerald-600'
                            }`}
                          >
                            {Number(b.actif) ? 'Désactiver' : 'Activer'}
                          </button>
                          {!cta && (
                            <button
                              type="button"
                              onClick={() => void updateBuildingCta(Number(b.id), buildingCtaLink[Number(b.id)] ?? String(b.cta_id || ''))}
                              className="rounded bg-cyan-800 px-2 py-0.5 text-[10px] text-white hover:bg-cyan-700"
                            >
                              Appliquer le lien CTA
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => void handleDelete('buildings', userId, Number(b.id))}
                            className="rounded bg-red-800 px-2 py-0.5 text-[10px] text-white hover:bg-red-700"
                          >
                            Supprimer
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={8} className="border-b border-[#263455] bg-[#080f22] px-2 py-1.5 text-[10px] text-slate-500">
                        Localisation : {b.localisation || '—'}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {filteredItems.length === 0 && <p className="p-3 text-xs text-slate-400">Aucun bâtiment trouvé.</p>}
        </div>
);

export default BuildingsModerationTab;
